export const GET_PRODUCTS_REQUEST="GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS="GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILE="GET_PRODUCTS_FAILE";


export const POST_CART_REQUEST="POST_CART_REQUEST";
export const POST_CART_SUCCESS="POST_CART_SUCCESS";
export const POST_CART_FAILE="POST_CART_FAILE";


export const GET_CART_REQUEST="GET_CART_REQUEST";
export const GET_CART_SUCCESS="GET_CART_SUCCESS";
export const GET_CART_FAILE="GET_CART_FAILE";

export const PATCH_CARTQUANTITY_REQUEST="PATCH_CARTQUANTITY_REQUEST";
export const PATCH_CARTQUANTITY_SUCCESS="PATCH_CARTQUANTITY_SUCCESS";
export const PATCH_CARTQUANTITY_FAILE="PATCH_CARTQUANTITY_FAILE";

export const DELETE_CART_REQUEST="DELETE_CART_REQUEST";
export const DELETE_CART_SUCCESS="DELETE_CART_SUCCESS";
export const DELETE_CART_FAILE="DELETE_CART_FAILE";